/**
 * Los cuatro niveles de `categorias`: **No · Viewer · Editor · Admin**. Editor crea, renombra y
 * mueve (xcons/xcons-docs#440); Admin además **borra** (xcons/xcons-docs#444).
 *
 * Los usan los dos paneles que lo conceden: el de operadores del store y el del seller
 * vinculado (xcons/xcons-docs#445), que es donde el store se lo da a todos los operadores de
 * un seller.
 */
import { NIVEL } from "@/utilities/niveles-de-permiso";
export const CATEGORY_OPTIONS = [
  { label: NIVEL.admin, value: "admin" },
  { label: NIVEL.editor, value: "editor" },
  { label: NIVEL.viewer, value: "viewer" },
  { label: NIVEL.no_access, value: "no_access" },
];

/**
 * `categorias` es siempre un dropdown, aunque el backend todavía lo declare SI/NO: mientras
 * no declare sus niveles se ofrecen todos, y elegir Viewer lo rechaza el backend viejo
 * al guardar. Cuando los declara, manda él —es quien sabe si el store puede tener Admin: en
 * uno que comparte el árbol de XCONS ofrece sólo No / Viewer—.
 */
export const opcionesDeCategorias = (item?: { options?: string[] }) => {
  const opciones = item?.options ?? [];
  const binario =
    opciones.length === 2 &&
    opciones.includes("admin") &&
    opciones.includes("no_access");
  return binario || !opciones.length
    ? CATEGORY_OPTIONS
    : CATEGORY_OPTIONS.filter((o) => opciones.includes(o.value));
};
